import { createAction } from '@reduxjs/toolkit'

export const reset = createAction('shared/reset')
